export default __webpack_public_path__ + "static/media/gabriela-wajnerman.81697c5d.png";